<span class="overline title">LAYOUT</span>

@let useEvenSplit = layoutStore.$ | async;
<mat-card
  appearance="outlined"
  *ngFor="let button of buttons"
  [class.selected]="useEvenSplit === button.value"
  (click)="changeLayout(button.value)"
>
  <mat-icon [svgIcon]="button.icon" class="split-icon"></mat-icon>
  <span class="caption"> {{ button.text }}</span>
  <mat-icon *ngIf="useEvenSplit === button.value">check_circle</mat-icon>
</mat-card>
<mat-divider></mat-divider>
<h3-persist-checkbox></h3-persist-checkbox>
